enum SCMProviderEnum {
  Github = 'github',
}

export default SCMProviderEnum
